import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

export const RecentPost = () => {
  const [posts, setPosts] = useState([]);
  const [currentPage] = useState(1);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    getData();
  }, [currentPage]);

  const getData = () => {
    axios
      .get("/post/public/shows", {
        params: {
          page: currentPage,
          limit: 4,
        },
      })
      .then((res) => {
        const postData = res.data.data?.posts;
        setPosts(postData);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="container-fluid">
        <h2 className="section-title position-relative text-uppercase mx-xl-5 mb-5 text-2xl font-bold">
          <span className="bg-secondary pr-3">Tin tức</span>
        </h2>
        <div className="row px-xl-5">
          {posts.map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
              <Link
                to={`tin-tuc/${item.slug}`}
                style={{ textDecoration: "none" }}
              >
                <div className="bg-light border rounded h-100 overflow-hidden">
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    className="img-fluid w-100"
                    style={{ objectFit: "cover", height: "180px" }}
                  />
                  <div className="p-3">
                    <h5>{item.title}</h5>
                    <p className="text-muted mb-0 post-description">
                      {item.short_description}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
